import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { BaseComponent } from "../classes/BaseComponent";
import { Global } from "../classes/Global";
import { StorageHelper } from "../helpers/StorageHelper";
import { ThemeService } from '../theme.service';

@Component({
  selector: 'app-store-selector',
  templateUrl: './store-selector.component.html',
  styleUrls: ['./store-selector.component.scss']
})
export class StoreSelectorComponent extends BaseComponent implements OnInit {
  @Input() stores = Global.supportedStores;
  @Input() deactivatedStores: string[] = [];
  @Input() useBrandIcons = false;
  @Output() onStoreChanged = new EventEmitter();

  constructor(
    private themeService: ThemeService
  ){
    super();
  }

  ngOnInit() {
  }

  isStoreSupported(store: string): boolean {
    return Global.isStoreSupported(store);
  }

  isStoreDeactivated(store: string): boolean {
    return this.deactivatedStores.indexOf(store) >= 0;
  }

  isActive(store: string): boolean {
    return store == Global.getStore();
  }

  select(store: string) {

    if(!this.isStoreSupported(store) || this.isStoreDeactivated(store)){
      return; //Do nothing, store not supported
    }

    if(store != Global.getStore()) {
      StorageHelper.getInstance().save(StorageHelper.keys.store, store);
      this.onStoreChanged.emit();
    }

  }

  getIconSuffix(store: string): string {
    if (store != Global.getStore()) {
      return "_grey.png";
    }
    if (store === Global.ITUNES && this.themeService.isDarkTheme()) {
      return "_white.png";
    }
    return ".png";
  }

  getIconPath(store:string):string {
    if (this.useBrandIcons) {
      const brandIconName = this.getBrandIconName(store);

      if (brandIconName != null) {
        return "./assets/images/store-icons/" + brandIconName;
      }
    }

    return "./assets/images/" + store + this.getIconSuffix(store);
  }

  getBrandIconName(store: string): string {
    if (store == Global.ITUNES) return "apple-tv.png";
    if (store == Global.VUDU) return "fandango.png";
    if (store == Global.AMAZON) return "prime-video.png";
    if (store == Global.GOOGLEPLAY || store == "googleplay") return "google-play.png";

    return null;
  }

  getStoreTitle(store: string): string {
    if (store == "itunes") return "Apple TV";
    if (store == "vudu") return this.getString("fandangoTitle");

    return this.getString(store);

  }

}
